import { ApolloLink, createHttpLink } from '@apollo/client/core';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
import { AwsConfiguration } from '../../ConfigContext/types';

export const httpAppsyncLink = (
  config: AwsConfiguration,
  tokenFn: () => string,
): ApolloLink => {
  const httpLink = createHttpLink({ uri: config.graphQLEndpoint });
  return createSubscriptionHandshakeLink(
    {
      url: config.graphQLEndpoint,
      region: config.region,
      auth: { type: 'AMAZON_COGNITO_USER_POOLS', jwtToken: tokenFn },
    },
    httpLink as any,
  ) as unknown as ApolloLink;
};
